type ButtonProps = {
  onClick?: () => void;
};

const Button = ({ onClick = (): null => null }: ButtonProps): React.ReactElement => (
  <button type="button" className="sub-header-base text-primary mt-2.5 ml-2.5" onClick={onClick}>
    Read more
  </button>
);

export default Button;
